var render = function render(){var _vm=this,_c=_vm._self._c;return _c('review-component',_vm._g(_vm._b({},'review-component',_vm.$props,false),_vm.$listeners),[_c(_vm.componentTag,{tag:"component",staticClass:"text"},[_vm._v(" <"+_vm._s(_vm.componentTag)+"> "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.component.getText(_vm.displayLanguage))}}),_vm._v(" </"+_vm._s(_vm.componentTag)+"> ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }